
































import axios from 'axios';
import { Page } from '../../../../Molecules/co-card-page/models.ts';
import CoCardPage from '../../../../Molecules/co-card-page/CoCardPage.vue';
import CoRoundButton from '../../../../Atoms/co-round-button/CoRoundButton.vue';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoCard from '../../../../Molecules/co-card/CoCard.vue';

type PageImage = {
    ImageURL: string | null;
};

type RenderedPage = Omit<Page, 'Owner' | 'Contributor' | 'FollowedBy'> & {
    Owner?: string[];
    Contributor?: string[];
    FollowedBy?: string[];
    ImageURL?: string[];
    Images?: PageImage[];
    Contributors?: Array<Record<string, unknown>>;
};

type PageFeedEntry = {
    object: RenderedPage;
};

export default {
    name: 'MyPages',
    data() {
        return {
            projects: Array<PageFeedEntry>(),
            channelList: [],
            userProfiles: {} as Record<string, Record<string, unknown>>,
            pages: Array<RenderedPage>(),
            me: this.$store.state.me,
            loading: false,
            contributorsToFetch: [],
        };
    },
    components: {
        CoCardPage,
        CoRoundButton,
        CoButton,
        CoCard,
    },
    computed: {
        canCreatePages() {
            return this.$store.state.permissions && this.$store.state.permissions['pages.create'] === true;
        },
    },
    created() {
        this.getChannelList();
    },
    mounted() {
        this.getMyPages();
    },
    methods: {
        create() {
            this.$router.push(`/create/page`);
        },
        mapFeedPostToPage(pageList: Array<PageFeedEntry>) {
            // map feed items to Page type
            const tmp = pageList.map((page: PageFeedEntry) => {
                const p: RenderedPage = page.object;
                const contributorIDs = p.Contributor || p.Owner || [];
                const contributors = contributorIDs.map((ID) => this.userProfiles[ID]).filter(Boolean);
                p.Contributors = contributors;
                p.Images = [
                    {
                        ImageURL: p.ImageURL && p.ImageURL[0] ? p.ImageURL[0] : null,
                    },
                ];
                return p;
            });
            this.pages = tmp;
        },
        getContributorProfiles(pageList: Array<RenderedPage>) {
            // build a deduplicated list of unique user IDs from all page contributors in the list
            const userIDs = (pageList || []).reduce((acc, page) => {
                const contributorIDs = page.Contributor || page.Owner || [];
                return acc.concat(contributorIDs);
            }, []);
            const uniqueUserIDs = Array.from(new Set(userIDs));
            // fetch user profiles for these unique user IDs if they are not already in the userProfiles map
            const idsToFetch = uniqueUserIDs.filter((id) => !this.userProfiles[id]);

            if (idsToFetch.length === 0) {
                return Promise.resolve();
            }
            const data = JSON.stringify({ IDS: idsToFetch.map((id) => ({ ID: id })) });
            return this.$store
                .dispatch('listUsersByIDs', { ids: data })
                .then((response) => {
                    if (response.Users) {
                        response.Users.forEach((user) => {
                            // Use a reactive assignment so contributor data stays in sync in Vue 2.
                            this.$set(this.userProfiles, user.ID, {
                                ...user,
                                ...user.Profile,
                            });
                        });
                    }
                })
                .catch((error) => {
                    console.log('Error fetching user profiles:', error);
                });
        },
        getChannelSlugByID(ID) {
            // get channel slug by ID
            let slug = '';
            this.channelList.forEach((channel) => {
                if (channel.object.ID === ID) {
                    slug = channel.object.Slug;
                }
            });
            return slug;
        },
        getMyPages() {
            this.loading = true;
            this.$store
                .dispatch('getMyProjects')
                .then(async (response) => {
                    this.projects = response.objects;
                    await this.getContributorProfiles(this.projects.map((project) => project.object));
                    this.mapFeedPostToPage(this.projects);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getChannelList() {
            return axios
                .get('/project/channel/list')
                .then((response) => {
                    if (response.data) {
                        this.channelList = response.data.objects;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.mapFeedPostToPage(this.projects);
                });
        },
    },
};
